import { TYPE_COLLECTION } from './input-types';
import { PROVIDER } from '../constants';

export const id = PROVIDER;
export const apiKey = 'ProviderId';
export const type = TYPE_COLLECTION;

export const provider = {
  id,
  apiKey,
  type,
};
